import { CaseStudy } from '../../types';

export const trophyTally: CaseStudy = {
  id: '4',
  title: 'Trophy Tally',
  category: 'Sport Achievement Tracking',
  imageUrl: 'https://images.unsplash.com/photo-1574629810360-7efbbe195018?q=80&w=1200&auto=format&fit=crop',
  description: 'A dedicated hub for competitors. Trophy Tally tracks every victory, milestone, and record across multiple disciplines. It turns your competitive life into a beautifully documented legacy.',
  screenshots: []
};